//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Icon from '../../core/Icon';

var NavigationButtonGroup = function NavigationButtonGroup(_ref) {
  var showUp = _ref.showUp,
      hasUp = _ref.hasUp,
      onUp = _ref.onUp,
      hasBack = _ref.hasBack,
      onBack = _ref.onBack,
      hasForward = _ref.hasForward,
      onForward = _ref.onForward;
  /** @type {Partial<import('../../core/Icon/Icon').Props>} */

  var common = {
    buttonSize: 'small',
    tooltipPlacement: 'top',
    hoverable: true
  };
  return React.createElement(Grid, {
    container: true,
    alignContent: "center",
    alignItems: "center",
    style: {
      height: 40,
      padding: 8
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, Object.assign({}, common, {
    type: "prev",
    onClick: onBack,
    disabled: !hasBack,
    label: "Back (Backspace, Alt + Left Arrow)"
  }))), React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, Object.assign({}, common, {
    type: "next",
    onClick: onForward,
    disabled: !hasForward,
    label: "Forward (Alt + Right Arrow)"
  }))), showUp && React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, Object.assign({}, common, {
    type: "up",
    onClick: onUp,
    disabled: !hasUp,
    label: "Up (Alt + Up Arrow)"
  }))));
};

NavigationButtonGroup.defaultProps = {
  showUp: false
};
export default NavigationButtonGroup;